<template>
  <div>
    <h1>Máquinas</h1>
    <v-btn
      outlined
      :to="{ name: 'AdminEnrolmentMachines' }"
      class="ma-2"
      color="indigo"
    >
      <v-icon left>mdi-ticket-account</v-icon>
      Matrículas
    </v-btn>
    <v-btn
      outlined
      :to="{ name: 'AdminGcpMachines' }"
      class="ma-2"
      color="indigo"
    >
      <v-icon left>mdi-google-cloud</v-icon>
      GCP
    </v-btn>
    <v-divider class="my-5"></v-divider>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'AdminMachines',
  data: () => ({
  }),
  mounted() {
  },
  methods: {
  },
};
</script>

<style>

</style>
